<template>
  <div class="page">
    <div
      class="menuemask"
      @click="changModalVisiable(false)"
      :class="{
        modaldisappear: !modalShow,
        lightmode: !isDark,
        darkmode: isDark,
      }"
    >
      <div class="menue-panel" @click="stoppop">
        <div class="mobile-menue">
          <div class="mobile-menue-title">
            <span>{{ $t('settings') }}</span>
            <img :src="closePng" @click="changModalVisiable(false)" />
          </div>
          <div class="mobile-menue-detail">
            <span>{{ $t('languages') }}</span>
            <div class="detail-right">
              <MobileLanguages />
              <img class="arrow" :src="rightArrow" />
            </div>
          </div>
          <div class="mobile-menue-detail">
            Dark Mode
            <div
              class="mode-change d-flex ai-center"
              :class="{ dark: isDark }"
              @click="changeMode"
            >
              <div class="mode-btn d-flex ai-center jc-center">
                <img class="mode" :src="modeImg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-header" :class="{ 'is-first-page': isFirstPage }">
      <div class="container d-flex ai-center jc-between">
        <img class="logo" :src="logoImg" @click="onIndex" />
        <img class="logo-mobile" :src="logoMobileImg" @click="onIndex" />
        <div
          class="showmore hidemodal"
          @click="changModalVisiable(true)"
          :class="{ isDark: isDark }"
        >
          <!-- <img src="../assets/more.png" /> -->
        </div>
        <div class="options">
          <div
            class="mode-change d-flex ai-center"
            :class="{ dark: isDark }"
            @click="changeMode"
          >
            <div class="mode-btn d-flex ai-center jc-center">
              <img :src="modeImg" />
            </div>
          </div>
          <Lauguages :is-first="isFirstPage" />
        </div>
      </div>

      <!-- 输入检测地址 -->
      <div class="header-wrap" v-if="!isFirstPage">
        <div
          class="header d-flex ai-center jc-between"
          v-if="isLoading || tokenInfo !== null || isError"
        >
          <div class="left-wrap d-flex ai-center">
            <div
              class="d-flex ai-center"
              ref="chainBtn"
              @click="onChain"
              :style="{ position: 'relative' }"
            >
              <img class="chain-icon" :src="chainList[chainIndex].icon" />
              <img v-if="isDark" class="down" src="../assets/down.png" />
              <img v-else class="down" src="../assets/down-black.png" />
            </div>
            <div class="vertical"></div>
            <input
              class="text"
              type="text"
              v-model="address"
              :placeholder="$t('placeholder')"
              @keydown.enter="beginCheck(address, blockchain_id)"
            />
            <img
              class="delete"
              v-show="address"
              @click="onDelete"
              :src="deleteImg"
            />
          </div>
          <div class="text button" @click="beginCheck(address, blockchain_id)">
            {{ $t('detection') }}
          </div>
          <ChainList
            v-show="isMask"
            :chainList="filteredChains"
            :isMask="isMask"
            isFirstPage
            @chooseChain="chooseChain"
            @onSearchFocus="onSearchFocus"
            isResult
          />
        </div>
        <img class="bg-img" src="../assets/header-img.png" alt="" />
      </div>
    </div>
    <div class="index" v-if="isFirstPage">
      <div class="main-container d-flex flex-column ai-center">
        <img class="main-img" src="../assets/index/index-img.png" />
        <div
          :class="{
            'chain-wrap': true,
            'd-flex': true,
            'ai-center': true,
            'jc-between': true,
            input_active: activeSelectedOrSearch,
          }"
          class="chain-wrap d-flex ai-center jc-between"
          @click="onChain"
        >
          <div class="cur-chain d-flex ai-center">
            <img :src="coicon" @click.stop="toggleMask" />
            <input
              v-model="searchQuery"
              :placeholder="$t('search_placeholder')"
              @focus="onSearchFocus('', true)"
              @blur="onSearchFocus('', false)"
              class="border-none-transparent input-indent"
              :class="{ dark: isDark }"
              :style="{ color: isDark ? '#fff' : '' }"
            />
          </div>
          <img class="down" src="../assets/index/down.png" />

          <ChainList
            v-show="isMask"
            :chainList="filteredChains"
            :isMask="isMask"
            @chooseChain="chooseChain"
          />
        </div>
        <div class="input-wrap d-flex ai-center">
          <input
            type="text"
            :placeholder="$t('placeholder')"
            v-model="address"
            @keydown.enter="beginCheck(address, blockchain_id)"
          />
          <img
            class="delete"
            v-show="address"
            @click="onDelete"
            :src="deleteImg"
          />
        </div>
        <div
          class="button text"
          :class="{ disabled: address === '' }"
          @click="beginCheck(address, blockchain_id)"
        >
          {{ $t('submit') }}
        </div>
      </div>
    </div>
    <div class="token-detection" v-else>
      <!-- 检测成功结果 -->
      <div class="detection-result" v-if="tokenInfo !== null && !isError">
        <div class="text content desc">
          {{ $t('detectionDesc') }}
        </div>
        <div class="content-detail">
          <div class="base-trade-contract">
            <!-- 基本信息 -->
            <div class="content base-content">
              <div class="title-wrapper">
                <div class="text title">{{ $t('baseInfo') }}</div>
                <div class="share-report" @click.stop="onShare">
                  <img src="../assets/share.png" alt="" />
                  <span>{{ $t('share_report') }}</span>
                </div>
              </div>
              <TokenOverview
                :risky="risky"
                :attention="attention"
                :symbol="symbol"
                :name="name"
                :icon="tokenIcon"
              />
              <div class="box">
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('contractAddress') }}
                  </div>
                  <div
                    class="d-flex ai-center address-item"
                    :class="{ coped: true }"
                    v-if="showAddress"
                  >
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(
                          showAddress,
                          chainData.chain_id,
                          blockchain_id,
                          true,
                        )
                      "
                    >
                      {{
                        showAddress.slice(0, 8) +
                        '...' +
                        showAddress.slice(-8)
                      }}
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click.stop="onCopy(showAddress, true)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ isSol ? $t('SOL.ownerProgram') : $t('contractOwner') }}
                  </div>
                  <div
                    class="d-flex ai-center owner-address-item"
                    :class="{ coped: true }"
                    v-if="
                      tokenInfo.owner_address && tokenInfo.owner_address !== ' '
                    "
                  >
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(
                          tokenInfo.owner_address,
                          chainData.chain_id,
                          blockchain_id,
                        )
                      "
                    >
                      <span v-if="tokenInfo.solTokenProgram">
                        {{ tokenInfo.solTokenProgram }}
                      </span>
                      <span v-else-if="tokenInfo.sol2022TokenProgram">
                        {{ tokenInfo.sol2022TokenProgram }}
                      </span>
                      <span v-else>
                        {{
                          tokenInfo.owner_address.slice(0, 8) +
                          '...' +
                          tokenInfo.owner_address.slice(-8)
                        }}
                      </span>
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click.stop="onCopy(tokenInfo.owner_address)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('contractCreator') }}
                  </div>
                  <div
                    class="d-flex ai-center creator-address-item"
                    :class="{ coped: true }"
                    v-if="tokenInfo.creator_address"
                  >
                    <div
                      class="text blue-text"
                      @click="
                        onBlockchainBrowser(
                          tokenInfo.creator_address,
                          chainData.chain_id,
                          blockchain_id,
                        )
                      "
                    >
                      {{
                        tokenInfo.creator_address.slice(0, 8) +
                        '...' +
                        tokenInfo.creator_address.slice(-8)
                      }}
                    </div>
                    <img
                      class="copy"
                      :src="copyImg"
                      @click.stop="onCopy(tokenInfo.creator_address)"
                    />
                  </div>
                  <div class="text word-break" v-else>~</div>
                </div>
                <div class="baseInfo d-flex ai-center jc-between">
                  <div class="text name">
                    {{ $t('releaseTotal') }}
                  </div>
                  <div
                    class="text word-break flex-1"
                    v-if="tokenInfo.total_supply"
                  >
                    {{ Number(tokenInfo.total_supply).toLocaleString() }}
                  </div>
                  <div v-else class="text word-break">~</div>
                </div>
              </div>
            </div>
            <TokenSecurityPanel
              :risky="risky"
              :attention="attention"
              :goPlusTax="goPlusTax"
              :certikTax="certikTax"
              :securityList="securityList"
              :isSol="isSol"
              :epoch="epoch"
              :goPlusBuyTaxColor="goPlusBuyTaxColor"
              :goPlusSellTaxColor="goPlusSellTaxColor"
              :certikBuyTaxColor="certikBuyTaxColor"
              :certikSellTaxColor="certikSellTaxColor"
              :showGoPlus="showGoPlusSecurityColumn"
              :showCertik="showCertikSecurityColumn"
            />
          </div>
          <div class="token-lp-holders">
            <!-- token-holders -->
            <div class="content token-holders" v-if="tokenInfo.holders">
              <div class="text title">{{ $t('tokenHolders') }}</div>
              <!-- <div class="line"></div> -->
              <div class="box">
                <div class="top-10 d-flex ai-center jc-between">
                  <div class="holder-number text" v-if="tokenInfo.holder_count">
                    <span>{{ $t('holdersNumber') }} :</span>
                    <span>{{ tokenInfo.holder_count }}</span>
                  </div>
                  <div class="percent-container">
                    <div class="text percent-title">
                      {{ $t('top10Holders') }} :
                    </div>
                  </div>
                  <div class="progress-wrapper">
                    <el-progress
                      :percentage="holdersPercent"
                      :show-text="false"
                      :stroke-width="28"
                    ></el-progress>
                    <span :class="{ black: holdersPercent < 18 }">{{ holdersPercent.toFixed(2) + '%' }}</span>
                  </div>
                </div>
                <div class="userInfo">
                  <UserInfoItem
                    v-for="(tItem, tIndex) in tokenInfo.holders"
                    :key="tIndex"
                    :item="tItem"
                    :index="tIndex"
                    :isSol="isSol"
                    :chain_id="Number(chainData.chain_id)"
                    :blockchain_id="Number(blockchain_id)"
                    @getToastTitle="getToastTitle"
                  />
                </div>
              </div>
            </div>
            <!-- lp-holders -->
            <div class="content token-holders lp-holders">
              <div class="text title">{{ $t('poolInfo') }}</div>
              <!-- <div class="line"></div> -->
              <div class="box">
                <template
                  v-if="tokenInfo.lp_holders && tokenInfo.lp_holders.length"
                >
                  <div class="top-10 d-flex ai-center jc-between">
                    <div
                      class="holder-number text"
                      v-if="tokenInfo.lp_holder_count"
                    >
                      <span>{{ $t('LPHolders') }} :</span>
                      <span>{{ tokenInfo.lp_holder_count }}</span>
                    </div>
                    <div class="text title title-mobile">
                      {{ $t('top10Holders') }}
                    </div>
                    <div class="percent-container">
                      <div class="text percent-title">
                        {{ $t('lockedPercent') }}
                      </div>
                    </div>
                    <div class="progress-wrapper">
                      <el-progress
                        :percentage="lockedPercent"
                        :show-text="false"
                        :stroke-width="28"
                      ></el-progress>
                      <span :class="{ black: lockedPercent < 18 }">{{ lockedPercent.toFixed(2) + '%' }}</span>
                    </div>
                  </div>
                  <div class="userInfo">
                    <UserInfoItem
                      lp_holders
                      v-for="(lItem, lIndex) in tokenInfo.lp_holders"
                      :key="lIndex"
                      :index="lIndex"
                      :item="lItem"
                      :isSol="isSol"
                      :chain_id="Number(chainData.chain_id)"
                      :blockchain_id="Number(blockchain_id)"
                      @getToastTitle="getToastTitle"
                    />
                  </div>
                </template>
                <LiquidityPool
                  :class="{ 'no-lp_holder': !tokenInfo.lp_holders }"
                  v-if="ammList.length"
                  :ammList="ammList"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 出错 -->
      <div
        class="text content error-content d-flex flex-column ai-center jc-between"
        v-else-if="isError"
      >
        <template v-if="!isContract">
          <img v-if="isDark" src="../assets/error-2-dark.png" />
          <img v-else src="../assets/error-2.png" />
          <span class="text">
            {{ $t('errorContract') }}
          </span>
        </template>
        <template v-else>
          <img v-if="isDark" src="../assets/error-1-dark.png" />
          <img v-else src="../assets/error-1.png" />
          <span class="text">
            {{ $t('errorData') }}
          </span>
        </template>
      </div>
      <div
        class="go-plus d-flex ai-center jc-center"
        v-if="!isLoading"
        @click.stop="'javascript:void';"
      >
        <a href="https://gopluslabs.io/" class="d-flex">
          <img v-if="isDark" src="../assets/go-plus-dark.png" />
          <img v-else src="../assets/go-plus.png" />
        </a>
      </div>
      <Toast
        v-if="isToast"
        :isCopyContract="isCopyContract"
        :isCopyReportLink="isCopyReportLink"
        :toastTitleObj="toastTitleObj"
        @closeToast="closeToast"
      >
        <ToastAddress
          v-if="toastTitleObj.metadata_mutable || toastTitleObj.transfer_hook"
          :addressList="metadata_upgrade_authority_address"
          :transferHookList="transfer_hook_address"
        />
      </Toast>
      <div class="loading-img d-flex ai-center jc-center" v-if="isLoading">
        <div class="loading-wrap d-flex flex-column ai-center jc-center">
          <img :src="loadingImg" />
          <span class="text">{{ $t('loading') }}</span>
        </div>
      </div>
    </div>
    <div class="mask-bg" v-show="isMask" @click="onMask"></div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import InfoItem from '../components/InfoItem.vue';
import UserInfoItem from '../components/UserInfoItem.vue';
import ChainList from '../components/ChainList.vue';
import Toast from '../components/Toast.vue';
import { GlobalMixins } from '../mixins';
import tokenSecurity from '../mixins/tokenSecurity';
import { NodeMap, setMode, CHAIN_INFO_MAP, parseWithUnit } from '../utils';
import { TP_SERVER_DOMAIN } from '../utils/config';
import LiquidityPool from '../components/LiquidityPool.vue';
import Lauguages from '../components/Lauguages.vue';
import MobileLanguages from '../components/MobileLanguages.vue';
import ToastAddress from '../components/ToastAddress.vue';
import TokenSecurityPanel from '../components/token-security/TokenSecurityPanel.vue';
import TokenOverview from '../components/token-security/TokenOverview.vue';

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
const BSE_URL = 'https://preserver.mytokenpocket.vip/';

export default {
  components: {
    InfoItem,
    UserInfoItem,
    Toast,
    ChainList,
    LiquidityPool,
    Lauguages,
    MobileLanguages,
    ToastAddress,
    TokenSecurityPanel,
    TokenOverview,
  },
  data() {
    return {
      blockchain_id: 1,
      isShowChainList: false,
      isCopyReportLink: false,
      chainIndex: 0,
      isContract: true,
      isMask: false,
      ammList: [],
      hid: undefined,
      swapMarketConfig: {},
      searchQuery: '',
      activeSelectedOrSearch: false,
      modalShow: false,
      legacyTokenSecurityDone: false,
      legacyTokenSecurityOk: false,
      reqTokenSecurityDone: false,
      reqTokenSecurityOk: false,
      chainData: {
        ns: 'ethereum',
        chain_id: '1',
      },
    };
  },
  mixins: [GlobalMixins, tokenSecurity],
  computed: {
    ...mapGetters(['isDark']),
    backgroundColor() {
      if (this.isDark) {
        return '#0e0e0e';
      } else {
        return '#f5f5f5';
      }
    },
    copyImg() {
      return require(`../assets/copy-blue.png`);
    },
    coicon() {
      const l = this.chainList.find((item) => item.label === this.searchQuery);
      return l ? l.icon : this.chainList[this.chainIndex].icon;
    },
    closePng() {
      return require(`../assets/close${this.isDark ? 'dark' : 'bright'}.png`);
    },
    filteredChains() {
      if (
        this.searchQuery.trim().length === 0 ||
        this.searchQuery === this.chainList[this.chainIndex]?.label
      ) {
        return this.chainList; // 当搜索查询为空时，显示全部
      }
      return this.chainList.filter((chain) =>
        chain.label
          .toLowerCase()
          .includes(this.searchQuery.trim().toLowerCase()),
      );
    },
    deleteImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/delete${str}.png`);
    },
    loadingImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/loading${str}.png`);
    },
    modeImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/mode${str}.png`);
    },
    rightArrow() {
      return require(`../assets/arrow-w.png`);
    },
    logoImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      if (this.isFirstPage) {
        return require(`../assets/index/index-logo${str}.png`);
      } else {
        return require(`../assets/index/index-logo${str}.png`);
      }
    },
    logoMobileImg() {
      let str = '';
      if (this.isDark) {
        str = '-dark';
      }
      return require(`../assets/index/index-logo${str}.png`);
    },
    queryObj() {
      let obj = {
        address: this.address,
        ns: this.chainData.ns,
        chain_id: this.chainData.chain_id,
      };
      if (this.blockchain_id) {
        obj.blockchain_id = this.blockchain_id;
      }
      return obj;
    },
    isTrading() {
      if (
        this.tradeList.length ||
        this.tokenInfo.buy_tax ||
        this.tokenInfo.sell_tax
      ) {
        return true;
      } else {
        return false;
      }
    },
    isError() {
      if (!this.isContract) return true;

      const legacyFailed = this.isDataError === true;
      const reqFailed = this.reqTokenSecurityDone && !this.reqTokenSecurityOk;
      return legacyFailed && reqFailed;
    },
    isFirstPage() {
      if (this.tokenInfo === null && !this.isError && !this.isLoading) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    queryObj(n) {
      this.$router.replace({
        path: `/`,
        query: { ...n },
      });
      this.pollingRateRequestCount = 0;
    },
  },
  created() {
    document
      .getElementsByTagName('link')[0]
      .setAttribute('href', '/favicon.ico');
    document.title = this.$t('tokenDetectionTitle');
    // console.log('route', this.$route);
    const { address, ns, chain_id, blockchain_id } = this.$route.query;
    const decodedAddress =
      typeof address === 'string'
        ? (() => {
            try {
              return decodeURIComponent(address);
            } catch (e) {
              return address;
            }
          })()
        : address;
    if (address && blockchain_id) {
      this.address = decodedAddress;
      this.blockchain_id = blockchain_id;
      this.chainData.ns = ns;
      this.chainData.chain_id = chain_id;
      this.chainList.forEach((chain, index) => {
        if (chain_id) {
          if (chain.chain_id == chain_id && chain.ns === ns) {
            this.chainIndex = index;
          }
        } else {
          if (chain.blockchain_id == blockchain_id) {
            this.chainIndex = index;
          }
        }
      });
      this.beginCheck(decodedAddress, blockchain_id);
    } else if (address && ns && chain_id) {
      this.address = decodedAddress;
      this.chainData.ns = ns;
      this.chainData.chain_id = chain_id;
      this.chainList.forEach((chain, index) => {
        if (chain_id) {
          if (chain.chain_id == chain_id && chain.ns === ns) {
            this.chainIndex = index;
          }
        }
      });
      this.blockchain_id = '';
      this.beginCheck(decodedAddress);
    } else {
      console.log('no');
    }
    // const regex = /[?&]blockchain_id=(\d+)/;
    // const match = window.location.href.match(regex);
    // const idstr = match ? match[1] : "";
    // if (match) {
    //   this.initIcon = this.chainList.find(
    //     (item) => item.chain_id === idstr
    //   ).icon;
    // } else {
    //   ("");
    // }
    // this.searchQuery = this.chainList[this.chainIndex].label;
  },
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    document.addEventListener('click', this.onOutside);
    document.body.style.overflow = 'auto';
    this.getSwapMarketConfig();
    this.searchQuery = this.chainList[this.chainIndex].label;
    document.body.addEventListener('click', () => {
      if (
        this.toastTitleObj.metadata_mutable ||
        this.toastTitleObj.transfer_hook
      ) {
        this.isToast = false;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onOutside);
  },
  methods: {
    stoppop(event) {
      event.stopPropagation();
    },
    changModalVisiable(bool) {
      this.modalShow = bool;
    },
    onShare() {
      if (!this.isToast) {
        this.isCopyReportLink = true;
        this.isToast = true;
        this.$copyText(window.location.href);
        setTimeout(() => {
          this.isToast = false;
          this.isCopyReportLink = false;
        }, 1000);
      }
    },
    onSearchFocus(searchQuery, bool) {
      if (bool) {
        this.searchQuery = '';
      } else if (searchQuery) {
        this.searchQuery = searchQuery;
      }
      this.activeSelectedOrSearch = bool;
    },
    async getPools(base_token, blockchain_id) {
      this.ammList = [];
      const response = await fetch(
        `${BSE_URL}/v1/swap_market/pools?blockchain_id=${blockchain_id}&base_token=${base_token}`,
      );
      const res = await response.json();
      if (res.result === 0 && res.data) {
        const list = res.data || [];
        const dexObj = this.swapMarketConfig[blockchain_id] && this.swapMarketConfig[blockchain_id].swap_router_map;
        const dexArr = Object.values(dexObj || {});
        this.ammList = list.map((item) => {
          let arr = dexArr.filter((d) => {
            return d.icon === item.icon;
          });
          let arr1 = [];
          if (this.tokenInfo && Array.isArray(this.tokenInfo.dex)) {
            arr1 = this.tokenInfo.dex.filter((d) => {
              return d.pair === item.pair;
            });
          }
          let name = '';
          if (arr1[0]) {
            name = arr1[0].name;
          } else {
            name = arr[0] && arr[0].name;
          }
          return {
            logo: item.icon,
            pair_address: item.pair,
            name: name,
            // liquidity: arr[0] ? arr[0].liquidity : '',
            pair: {
              symbol0: item.symbol0,
              symbol1: item.symbol1,
              reserve0: parseWithUnit(item.reserve0, 'vol'),
              reserve1: parseWithUnit(item.reserve1, 'vol'),
            },
            value: parseWithUnit(item.market_value, 'vol'),
          };
        });
      }
    },
    async getSwapMarketConfig() {
      try {
        const response = await fetch(`${BSE_URL}/v1/swap_market/config`, {
          headers: { os: 'web' },
        });
        const res = await response.json();
        if (res.result === 0 && res.data) {
          this.swapMarketConfig = res.data;
        }
      } catch (error) {
        console.log('swap_market/config错误', error);
      }
    },

    toggleMask() {
      // alert("2222");
      this.isMask = !this.isMask;
      if (this.searchQuery) {
        this.searchQuery = '';
      }
    },
    onMask() {
      this.isMask = false;
      this.searchQuery = '';
      document.body.style.overflow = 'auto';
      this.searchQuery = this.chainList[this.chainIndex].label;
    },
    onIndex() {
      this.tokenInfo = null;
      this.isDataError = false;
      this.address = '';
      this.blockchain_id = 1;
      this.chainData.ns = 'ethereum';
      this.chainData.chain_id = '1';
      this.chainIndex = 0;
      document.body.style.overflow = 'auto';
      // this.isFirstPage = false;
      this.searchQuery = this.chainList[this.chainIndex].label;
    },
    onDelete() {
      this.address = '';
    },
    onChain() {
      this.isMask = true;
      document.body.style.overflow = 'hidden';
    },
    changeMode() {
      let mode = document.documentElement.hasAttribute('theme');
      setMode(!mode);
      this.$store.commit('setDark', !mode);
      if (mode) {
        window.localStorage.setItem('mode', 'light');
      } else {
        window.localStorage.setItem('mode', 'dark');
      }
    },
    getToastTitle(obj) {
      this.toastTitleObj = obj;
      if (!this.isToast) {
        this.isToast = true;
        if (!obj.metadata_mutable) {
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        }
      }
    },
    onOutside(e) {
      const chainBtn = this.$refs.chainBtn;
      if (chainBtn && !chainBtn.contains(e.target)) {
        const contentWrap = document.querySelector('.select-chain');
        if (contentWrap && !contentWrap.contains(e.target)) {
          this.isShowChainList = false;
        }
      }
    },

    async beginCheck(address, blockchain_id) {
      this.isMask = false;
      if (!address) {
        return;
      }
      let contractAddress = address;
      let bl_symbol = undefined;
      if (Number(blockchain_id) === 48) {
        contractAddress = address.split('::')[0];
        const regex = /::(.*)/;
        bl_symbol = address.match(regex) && address.match(regex)[1];
      }

      this.isDataError = false;
      this.isLoading = true;
      this.legacyTokenSecurityDone = false;
      this.legacyTokenSecurityOk = false;
      this.reqTokenSecurityDone = false;
      this.reqTokenSecurityOk = false;
      if (this.isSol) {
        this.getSolEpoch();
      }
      this.resetTokenSecurityResults();
      this.getTokenBatch(contractAddress, Number(blockchain_id));

      const legacyPromise = Promise.resolve(
        this.tokenSecurity(contractAddress, blockchain_id, this.chainData, bl_symbol),
      )
        .then(() => {
          this.legacyTokenSecurityDone = true;
          this.legacyTokenSecurityOk = this.tokenInfo !== null;
          if (this.legacyTokenSecurityOk) {
            this.isLoading = false;
          } else {
            this.isDataError = true;
          }
        })
        .catch(() => {
          this.legacyTokenSecurityDone = true;
          this.legacyTokenSecurityOk = false;
          this.isDataError = true;
        });

      const reqPromise = Promise.resolve(
        this.getTokenSecurity(contractAddress, blockchain_id, this.chainData),
      )
        .then((data) => {
          this.reqTokenSecurityDone = true;
          this.reqTokenSecurityOk = !!data;

          if (data) {
            if (this.tokenInfo === null) {
              this.tokenInfo = {};
            }
            this.isLoading = false;
            if (Number(blockchain_id) === 27) {
              this.formatSolData(data);
            } else {
              this.formatEvmData(data);
            }
          }
          return data;
        })
        .catch(() => {
          this.reqTokenSecurityDone = true;
          this.reqTokenSecurityOk = false;
          return null;
        });

      await Promise.allSettled([legacyPromise, reqPromise]);

      if (!this.legacyTokenSecurityOk && !this.reqTokenSecurityOk) {
        this.isLoading = false;
      }
      // this.getTokenSecurity(address, blockchain_id, this.chainData).then((data) => {
      // });
      // 只支持 EVM 和已经支持了交易记录的链
      if (blockchain_id) {
        this.getPools(contractAddress, blockchain_id);
      }
      if (this.tokenInfo && !this.tokenInfo['owner_address'] && !this.isSol) {
        this.isContract = await this.getCode(
          address,
          NodeMap[this.chainData.chain_id],
          this.chainData.chain_id,
        );
      } else {
        this.isContract = true;
      }
    },

    openChainList() {
      this.isShowChainList = true;
    },
    chooseChain(index, blockchain_id, chain_id, ns) {
      document.body.style.overflow = 'auto';
      const selected = this.chainList.findIndex((chain) => {
        return chain.chain_id === chain_id && chain.ns === ns;
      });
      this.isMask = false;
      this.chainIndex = selected;
      this.blockchain_id = blockchain_id;
      this.searchQuery = this.chainList[this.chainIndex].label;
      this.isShowChainList = false;
      this.chainData.chain_id = chain_id;
      this.chainData.ns = ns;
      this.beginCheck(this.address, this.blockchain_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.modaldisappear {
  display: none !important;
}
.page {
  background: var(--bg-9);
  min-height: 100vh;
}
.input-indent {
  margin-left: 0.2rem;
  font-weight: 400;
  font-size: 0.14rem;
}
.main-header {
  position: relative;
  padding: 0 0 0.42rem;
  background: var(--bg-11);
  .options {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    // top: -20px;
    min-width: 200px;
  }
  &.is-first-page {
    background: none;
  }
  .container {
    max-width: 12rem;
    margin: 0 auto;
  }
  .logo {
    height: 0.24rem;
    cursor: pointer;
  }
  .logo-mobile {
    display: none;
  }
  .mode-change {
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 0.18rem;
    padding: 0.02rem;
    justify-content: center;
    cursor: pointer;
    .mode-btn {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 0.15rem;
      transition: transform 0.5s;
      &.dark {
        transform: translateX(0.22rem);
      }
      img {
        width: 0.24rem;
        height: 0.24rem;
      }
    }
  }
  .vertical {
    width: 0.01rem;
    height: 0.24rem;
    background: var(--input-border);
  }
  .header-wrap {
    position: relative;
    max-width: 12rem;
    margin: 0 auto;
    margin-top: 0.32rem;
    .header {
      max-width: 7.6rem;
      position: relative;
      z-index: 100;
      .left-wrap {
        position: relative;
        flex: 1;
        height: 0.44rem;
        padding: 0 0.15rem 0 0.1rem;
        background: var(--bg-14);
        border-radius: 0.12rem;
        border: 0.01rem solid var(--border-1);
        .chain-icon {
          width: 0.3rem;
          height: 0.3rem;
          cursor: pointer;
        }
        .down {
          margin: 0 0.16rem 0 0.08rem;
          width: 0.14rem;
          cursor: pointer;
        }
        input {
          margin-left: 0.16rem;
          border: none;
          width: 2rem;
          width: 100%;
          font-size: 0.14rem;
          background: var(--chain-list-bg);
          color: var(--gray-10);
        }
        .delete {
          width: 0.14rem;
        }
      }
      .button {
        margin-left: 0.12rem;
        padding: 0 0.25rem;
        height: 0.44rem;
        line-height: 0.44rem;
        background: #2980fe;
        border-radius: 0.12rem;
        font-size: 0.12rem;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .desc {
      max-width: 7.6rem;
      margin: 0;
      margin-top: 0.16rem;
      width: 100%;
      padding: 0.1rem 0.2rem;
      font-size: 0.12rem;
      font-family: PingFang SC, PingFang SC-Regular;
      background: rgba(255, 113, 20, 0.1);
      border: 0.01rem solid #ff7114;
      border-radius: 0.08rem;
      color: #fff;
      color: #ff7114;
    }
    .bg-img {
      width: 1.98rem;
      height: 1.47rem;
      position: absolute;
      bottom: -0.25rem;
      right: 1.8rem;
    }
  }
}
.index {
  .main-container {
    .main-img {
      width: 3rem;
      height: 1.97rem;
      margin-top: 0.5rem;
    }
    .chain-wrap {
      position: relative;
      z-index: 100;
      width: 4.4rem;
      padding: 0.1rem 0.18rem 0.1rem 0.1rem;
      background: var(--chain-bg);
      border: 0.01rem solid var(--chain-border);
      border-radius: 0.12rem;
      margin-top: 0.24rem;
      .cur-chain {
        img {
          width: 0.3rem;
        }
        span {
          margin-left: 0.1rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: var(--gray-10);
          line-height: 0.2rem;
        }
      }
      .down {
        width: 0.14rem;
      }
    }
    .input-wrap {
      margin-top: 0.1rem;
      width: 4.4rem;
      background: var(--input-bg);
      border: 0.01rem solid var(--input-border);
      border-radius: 0.12rem;
      padding: 0 0.2rem;
      input {
        width: 100%;
        height: 0.5rem;
        border: none;
        // background: var(--input-bg);
        background: none;
        color: var(--gray-10);
      }
      img {
        margin-left: 0.1rem;
        width: 0.14rem;
        height: 0.14rem;
        cursor: pointer;
      }
      input::-webkit-input-placeholder {
        /* 使用webkit内核的浏览器 */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
      input:-moz-placeholder {
        /* Firefox版本4-18 */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
      input::-moz-placeholder {
        /* Firefox版本19+ */
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: var(--placeholder);
      }
    }
    .border-none-transparent {
      border: none;
      background: transparent;
    }
    // .input-indent {
    //   margin-left: 0.2rem;
    //   font-weight: 400;
    //   font-size: 0.26rem;
    // }
    .input_active {
      border: 1px solid #2980fe !important;
    }
    .button {
      margin-top: 0.16rem;
      width: 4.4rem;
      height: 0.5rem;
      line-height: 0.5rem;
      // background: var(--btn-bg);
      background: #2980fe;
      text-align: center;
      border-radius: 0.12rem;
      font-size: 0.14rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #ffffff;
      cursor: pointer;
      &.disabled {
        color: #2980fe;
        background: var(--disabled-btn-bg);
      }
    }
  }
}
.mask-bg {
  position: absolute;
  z-index: 99;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
}
.token-detection {
  position: relative;
  width: 12rem;
  margin: 0 auto;
  background: var(--bg-9);
  .detection-result {
    .content {
      width: 100%;
      border-radius: 0 0 0.12rem 0.12rem;
    }
    .desc {
      // max-width: 7.6rem;
      margin: 0;
      margin-top: 0.16rem;
      width: 100%;
      padding: 0.1rem 0.2rem;
      font-size: 0.12rem;
      font-family: PingFang SC, PingFang SC-Regular;
      background: rgba(255, 113, 20, 0.1);
      border: 0.01rem solid #ff7114;
      border-radius: 0.08rem;
      color: #fff;
      color: #ff7114;
    }
    .content-detail {
      margin-top: 20px;
      display: flex;
      gap: 20px;
    }
    .title {
      padding: 0;
      font-size: 0.18rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: left;
      color: var(--gray-10);
      line-height: 0.22rem;
      // margin-bottom: 0.1rem;
    }
    .box {
      // padding: 0 0.2rem 0.2rem;
    }
    .base-trade-contract {
      flex: 1;
      min-width: 0;
      .name {
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: var(--gray-14);
        min-width: auto;
        line-height: normal;
      }
    }
    .base-content {
      background: var(--bg-14);
      // border: 0.01rem solid var(--border-1);
      border-radius: 12px;
      box-shadow: var(--box-shadow-1);
      padding: 18px 20px;
      .title-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .share-report {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          border: 1px solid var(--border-1);
          padding: 4px 10px;
          border-radius: 6px;
          cursor: pointer;
          img {
            width: 12px;
            height: 12px;
          }
          span {
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Regular;
            color: var(--color-29);
          }
        }
      }
      .baseInfo {
        margin-top: 0.1rem;
        .word-break {
          margin-left: 0.5rem;
          text-align: right;
          word-break: break-word;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFang SC-Medium;
          text-align: right;
          color: var(--gray-10);
          line-height: 0.2rem;
        }
        .blue-text {
          width: 1.96rem;
          font-size: 0.14rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: right;
          // color: var(--gray-10);
          color: #2980fe;
          line-height: 0.2rem;
        }
        .blue-text:hover {
          text-decoration: underline;
        }
        .copy {
          margin-left: 0.06rem;
          width: 0.14rem;
          height: 0.14rem;
          cursor: pointer;
        }
      }
    }
    .token-lp-holders {
      flex: 1;
      min-width: 0;
    }
    .token-holders {
      background: var(--bg-14);
      margin-bottom: 0.16rem;
      // border: 0.01rem solid var(--border-1);
      border-radius: 0.12rem;
      box-shadow: var(--box-shadow-1);
      padding: 18px 20px;
      .title {
        width: fit-content;
        // background: var(--bg-12);
        // border-radius: 0 0.18rem 0.18rem 0;
        // padding: 0.05rem 0.3rem 0.05rem 0.16rem;
        // margin: 0.16rem 0 0.18rem;
        line-height: normal;
      }
      .top-10 {
        padding: 0;
        margin-top: 0.06rem;
        flex-direction: column;
        align-items: flex-start;
        .holder-number {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 6px;
          // justify-content: space-between;
          span {
            color: var(--gray-10);
            font-size: 14px;
            font-weight: 500;
          }
        }
        .percent-container {
          margin-top: 12px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .percent-title {
            color: var(--gray-10);
            white-space: nowrap;
            font-size: 0.14rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
          }
        }

        .progress-wrapper {
          position: relative;
          margin-top: 6px;
          width: 100%;
          ::v-deep {
            .el-progress-bar__outer {
              border-radius: 4px;
              background: var(--bg-13) !important;
            }
            .el-progress-bar__inner {
              border-radius: 4px;
              /* 使用 background 代替 background-color */
              background: linear-gradient(270deg, #53b7ff, #2980fe) !important;
            }
          }

          span {
            position: absolute;
            left: 8px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            &.black {
              color: var(--color-16);
            }
          }
        }
        .title {
          // margin-top: 0.16rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: var(--gray-10);
          line-height: 0.17rem;
          // margin-bottom: 0.07rem;
        }
      }
      .userInfo {
        margin-top: 16px;
        padding: 0.04rem 0.16rem 0.16rem;
        background: var(--bg-15);
        border-radius: 0.12rem;
      }
    }
    .lp-holders {
      background: var(--bg-14);
      .title-mobile {
        display: none;
      }
    }
  }
  .error-content {
    position: relative;
    padding: 1.64rem 0;
    margin: 0 auto;
    text-align: center;
    img {
      width: 1.14rem;
      height: 0.98rem;
    }
    span {
      margin-top: 0.16rem;
      font-size: 0.14rem;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      padding: 0 0.3rem;
      color: var(--gray-13);
    }
  }
  .go-plus {
    margin-top: 0.4rem;
    img {
      width: 3.23rem;
      height: 0.48rem;
    }
  }
  .loading-img {
    background: var(--bg-9);
    padding-top: 1.05rem;
    @keyframes rotate {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(180deg);
      }
    }
    img {
      width: 0.58rem;
      height: 0.58rem;
      transition: transform 1s linear;
      animation: rotate 1s linear infinite;
    }
    span {
      margin-top: 0.12rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: var(--gray-13);
    }
  }
}

@media screen and (max-width: 767px) {
  .lightmode {
    .menue-panel {
      position: relative;
      width: 100%;
      height: fit-content;
      padding: 0 24px;
      .mobile-menue {
        width: 100%;
        background: #fff;
        border-radius: 16px;
        padding: 0 16px;
        .mobile-menue-title {
          font-size: 0.32rem;
          font-weight: 600;
          border-bottom: 1px solid #999;
          height: 1.3rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
          }
        }
        .mobile-menue-detail {
          height: 1.24rem;
          font-size: 0.28rem;
          font-weight: 600;
          // padding: 16px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .detail-right {
            display: flex;
            align-items: center;
            img {
              width: 0.24rem;
              height: 0.24rem;
              margin-left: 0.08rem;
            }
          }
          .mode-btn {
            img {
              width: 0.36rem;
              height: 0.36rem;
            }
          }
        }
      }
    }
  }
  .darkmode {
    .menue-panel {
      position: relative;
      width: 100%;
      height: fit-content;
      padding: 0 24px;
      .mobile-menue {
        width: 100%;
        background: #212326;
        border-radius: 16px;
        padding: 0 16px;
        .mobile-menue-title {
          font-size: 0.32rem;
          font-weight: 600;
          color: #fff;
          border-bottom: 1px solid #444;
          height: 1.3rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
          }
        }
        .mobile-menue-detail {
          font-size: 0.28rem;
          font-weight: 400;
          color: #fff;
          height: 1.24rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .detail-right {
            display: flex;
            align-items: center;
            img {
              width: 0.24rem;
              height: 0.24rem;
              margin-left: 0.08rem;
            }
          }
          .mode-btn {
            img {
              width: 0.36rem;
              height: 0.36rem;
            }
          }
        }
      }
    }
  }
  .showmore {
    width: 0.48rem;
    height: 0.48rem;
    cursor: pointer;
    background: url('../assets/showmore.png') no-repeat;
    background-size: cover;
    &.isDark {
      background: url('../assets/showmore_light.png') no-repeat;
      background-size: cover !important;
    }
  }
  .menuemask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .page {
    // background: var(--bg-1);
  }
  .input-indent {
    margin-left: 0.3rem;
    font-weight: 400;
    font-size: 0.26rem;
    &.dark {
      color: #fff;
    }
  }
  .main-header {
    width: calc(100% - 0.64rem);
    padding: 0.3rem 0 0;
    margin: 0 auto;
    background: none;
    .options {
      display: none;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      // top: -20px;
      min-width: 200px;
    }
    .container {
      max-width: none;
    }
    .logo {
      display: none;
      height: 0.36rem;
    }
    .logo-mobile {
      display: block;
      height: 0.36rem;
    }
    .mode-change {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 0.25rem;
      justify-content: center;
      .mode-btn {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.21rem;
        &.dark {
          transform: translateX(0.33rem);
        }
        img {
          width: 0.4rem;
          height: 0.4rem;
        }
      }
    }
    .header-wrap {
      .header {
        // margin: 0 0.32rem;
        position: relative;
        .left-wrap {
          flex: 1;
          height: 0.89rem;
          padding: 0 0.24rem;
          background: var(--chain-input-bg);
          border-radius: 0.16rem;
          .chain-icon {
            width: 0.56rem;
            height: 0.56rem;
            cursor: pointer;
          }
          .down {
            margin: 0 0.16rem 0 0.16rem;
            width: 0.2rem;
            cursor: pointer;
          }
          input {
            margin-left: 0.16rem;
            margin-right: 0.1rem;
            border: none;
            width: 2rem;
            width: 100%;
            font-size: 0.26rem;
            // background: var(--bg-9);
            background: none;
          }
          .delete {
            width: 0.26rem;
          }
        }
        .button {
          margin-left: 0.24rem;
          padding: 0 0.25rem;
          height: 0.84rem;
          line-height: 0.84rem;
          background: #2980fe;
          border-radius: 0.16rem;
          font-size: 0.28rem;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .desc {
        border-radius: 0.16rem;
        margin-top: 0.2rem;
        padding: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFang SC, PingFang SC-Regular;
        // background: rgba(255, 113, 20, 1);
        // color: #ff7114;
        // color: #fff;
      }
      .bg-img {
        display: none;
      }
    }
  }
  .index {
    .main-container {
      .main-img {
        width: 5.4rem;
        height: 3.54rem;
      }
      .chain-wrap {
        width: calc(100% - 0.64rem);
        padding: 0.18rem 0.3rem 0.18rem 0.2rem;
        .cur-chain {
          img {
            width: 0.62rem;
          }
          span {
            font-size: 0.26rem;
          }
        }
        .down {
          width: 0.2rem;
        }
      }
      .input-wrap {
        width: calc(100% - 0.64rem);
        padding: 0 0.3rem;
        input {
          height: 0.98rem;
          font-size: 0.26rem;
        }
        img {
          margin-left: 0.2rem;
          width: 0.26rem;
          height: 0.26rem;
        }
        input::-webkit-input-placeholder {
          /* 使用webkit内核的浏览器 */
          font-size: 0.26rem;
        }
        input:-moz-placeholder {
          /* Firefox版本4-18 */
          font-size: 0.26rem;
        }
        input::-moz-placeholder {
          /* Firefox版本19+ */
          font-size: 0.26rem;
        }
      }
      .button {
        width: calc(100% - 0.64rem);
        height: 0.98rem;
        line-height: 0.98rem;
        font-size: 0.26rem;
      }
    }
  }
  .token-detection {
    padding: 0 0 1rem;
    width: 100%;
    margin-top: 0.2rem;
    .vertical {
      width: 0.01rem;
      height: 0.24rem;
      background: var(--input-border);
    }
    .detection-result {
      display: block;
      .content {
        width: calc(100% - 0.64rem);
        padding-bottom: 0.32rem;
        border-radius: 8px;
      }
      .desc {
        margin: 0 auto;
        margin-bottom: 0.2rem;
        padding: 0.24rem;
        font-size: 0.26rem;
      }
      .content-detail {
        flex-direction: column;
        margin-top: 0.2rem;
        gap: 10px;
      }
      .base-trade-contract {
        width: auto;
        .name {
          font-size: 0.26rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          min-width: auto;
          line-height: normal;
          min-width: 2rem;
        }
      }
      .title {
        // padding: 0.21rem 0 0.21rem 0.32rem;
        font-size: 14px;
        line-height: normal;
        margin-bottom: 0;
      }
      .box {
        padding: 0;
        border: none;
        border-radius: 0.12rem;
      }
      .base-content {
        padding: 0.3rem 0.32rem;
        .title {
          background: none;
          padding: 0;
        }
        .baseInfo {
          padding: 0;
          margin-top: 0.3rem;
          .blue-text {
            width: auto;
            font-size: 0.26rem;
            line-height: normal;
          }
          .word-break {
            font-size: 0.26rem;
            margin-left: 0.5rem;
            text-align: right;
            word-break: break-word;
            line-height: normal;
          }
          .copy {
            margin-left: 0.18rem;
            width: 0.28rem;
            height: 0.28rem;
            cursor: pointer;
          }
        }
      }
      .token-lp-holders {
        margin-left: 0;
      }
      .token-holders {
        padding: 0.3rem 0.32rem;
        margin-bottom: 0.2rem;
        .box {
          margin-top: 16px;
        }
        .top-10 {
          padding: 0;
          margin-top: 0;
          // flex-direction: row;
          align-items: center;
          .holder-number {
            // display: none;
            span {
              font-size: 12px;
            }
          }
          .percent-container {
            .percent-title {
              font-size: 12px;
            }
          }
          .title {
            padding: 0;
            margin-top: 0;
            font-size: 0.26rem;
            margin-bottom: 0;
            line-height: normal;
          }
        }
        .userInfo {
          padding: 0;
          background: none;
          margin-top: 16px;
        }
      }
      .lp-holders {
        .userInfo {
          display: block;
        }
        .title-mobile {
          display: none;
        }
      }
    }
    .error-content {
      padding: 1.64rem 0;
      margin: 0 auto;
      text-align: center;
      img {
        width: 1.14rem;
        height: 0.98rem;
      }
      span {
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        padding: 0 0.3rem;
      }
    }
    .go-plus {
      margin-top: 0.4rem;
      img {
        width: 3.23rem;
        height: 0.48rem;
      }
    }
    .loading-img {
      img {
        width: 0.88rem;
        height: 0.88rem;
      }
      span {
        margin-top: 0.2rem;
        font-size: 0.24rem;
      }
    }
  }
}
</style>
